import { render, staticRenderFns } from "./depitByBusR.vue?vue&type=template&id=27844b52&scoped=true&"
import script from "./depitByBusR.vue?vue&type=script&lang=js&"
export * from "./depitByBusR.vue?vue&type=script&lang=js&"
import style0 from "./depitByBusR.vue?vue&type=style&index=0&id=27844b52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27844b52",
  null
  
)

export default component.exports